import { render, staticRenderFns } from "./SubModal.vue?vue&type=template&id=ff32ae7c&scoped=true&"
import script from "./SubModal.vue?vue&type=script&lang=js&"
export * from "./SubModal.vue?vue&type=script&lang=js&"
import style0 from "./SubModal.vue?vue&type=style&index=0&id=ff32ae7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff32ae7c",
  null
  
)

export default component.exports